var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitedstatesofamerica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 10,
    viewBox: "0 0 40 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3457 9515)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -18)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 9.6,
    transform: "translate(-3457 -9497)",
    fill: "#167ed8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4.8,
    transform: "translate(-3443 -9497)",
    fill: "#ed5200"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4.8,
    transform: "translate(-3443 -9492.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 4.8,
    transform: "translate(-3457 -9487.4)",
    fill: "#ed5200"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 4.8,
    transform: "translate(-3457 -9482.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 4.8,
    transform: "translate(-3457 -9477.8)",
    fill: "#ed5200"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3455 -9495.2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(0 5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(2.25 2.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(6.75 2.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(4.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(4.5 5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(9 5)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-3541.218-8606h-5.49l-14.51,24h20Z",
    transform: "translate(124.218 -909)",
    opacity: 0.095
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedstatesofamerica);
export default __webpack_public_path__ + "static/media/UNITED STATES OF AMERICA.60be3a30f6a7e723298cfbaf32c1c40e.svg";
export { ForwardRef as ReactComponent };